const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCat5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2122 2122",
    style: {
      enableBackground: "new 0 0 2122 2122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M838.795,1743.003L838.795,1743.003c60.412,15.21,120.419,24.598,182.242,27.75 C959.213,1767.601,899.206,1758.213,838.795,1743.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M532.248,806.31c2.73-6.206,5.513-12.387,8.347-18.543 C537.761,793.924,534.979,800.104,532.248,806.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1372.434,1462.256c-38.799-23.195-84.328-31.81-125.391-49.973 c-39.094-17.292-76.54-41.328-104.912-73.631c-28.09-31.98-44.648-73.304-36.09-116.077c6.739-33.681,23.058-66.806,50.082-88.675 c48.274-39.066,117.953-36.575,176.534-38.15c52.188-1.403,112.71-2.673,155.924-35.498 c-23.893-62.766-50.451-124.628-75.965-185.863c-8.786-21.086-90.903-142.098-81.446-162.892 c14.786-32.512,24.788-43.541,43.241-57.056c-35.517,14.348-74.186,20.314-112.535,16.93c-5.882-0.519-5.917-9.756,0-9.233 c2.888,0.255,5.777,0.452,8.667,0.6c-1.125-0.385-2.256-0.753-3.364-1.2c22.904-48.225,83.156-45.385,128.508-36.818 c5.299,1.001,10.569,2.142,15.828,3.327c-1.69,1.316-3.36,2.666-5.091,3.909c-0.69,0.496-1.302,0.922-1.976,1.403 c0,0,0,0.001,0,0.001c0.672-0.48,1.286-0.908,1.976-1.403c45.463-32.672,77.015-90.78,74.302-146.698 c-0.258-5.327-1.063-10.987-2.299-16.865c-10.374,1.5-20.757,2.947-31.157,4.287c-4.733,0.61-5.546-5.188-2.689-7.896 c-31.993-2.317-61.972-10.661-81.635-37.064c-14.555-19.547-32.784-52.513-62.169-45.325c-12.759,3.12-19.903,13.631-25.779,24.626 c-22.788,42.644-32.374,79.912-76.245,106.854c-61.711,37.897-171.628,80.311-241.467,40.655 c8.32,6.998,17.134,13.428,26.177,19.405c22.901,15.138,47.191,28.108,71.709,40.4c5.319,2.666,0.638,10.628-4.66,7.972 c-27.848-13.96-55.55-28.752-81.028-46.766c-24.747-17.496-48.456-38.87-58.459-68.328c-8.065-23.751-6.794-49.663-8.362-74.367 c-0.132-2.075,0.937-3.376,2.363-3.997c-4.018-44.336-3.758-88.808-1.052-135.107c0.052-0.891-0.403-1.737-0.585-2.611 c-37.463,52.064-56.472,93.312-98.586,140.917c-0.185,32.881-0.392,66.201,7.102,98.299c8.663,37.104,29.475,69.267,57.686,94.623 c23.218,20.869,49.81,37.56,73.911,57.34c22.673,18.61,45.587,41.066,52.19,70.743c7.189,32.307-7.43,69.481-31.358,91.486 c-23.483,21.596-56.226,27.201-87.066,27.391c-32.536,0.201-64.786-5.037-97.068-8.362c-34.804-3.584-67.383,4.225-99.318,17.84 c-32.786,13.978-63.366,32.482-95.745,47.312c-29.496,13.509-62.407,24.495-95.225,19.022c-3.025-0.505-6.008-1.18-8.97-1.934 c-23.589,79.306-37.953,158.886-41.023,233.179c-1.874,45.352,1.457,90.857,9.622,135.491c23.552-3.008,46.535-12.516,67.89-22.332 c34.137-15.691,68.244-37.041,105.833-43.139c29.971-4.862,62.376-7.108,91.383,3.664c23.051,8.561,40.764,26.091,54.753,45.822 c38.829,54.769,60.434,119.966,98.446,175.255c18.25,26.545,41.165,49.568,70.105,64.272c34.992,17.779,75.03,22.567,112.115,34.47 c38.702,12.422,74.991,34.062,94.421,71.083c17.431,33.211,19.535,71.813,25.263,108.185c0.746,4.736,1.572,9.457,2.473,14.164 c35.041-4.253,76.462-11.171,118.23-20.639c11.832-8.202,23.123-17.207,33.789-26.911c28.491-25.923,55.525-55.938,76.53-88.266 c12.63-19.438,23.902-40.03,37.426-58.761c-0.472-21.549-5.53-42.236-16.809-60.98 C1409.361,1490.371,1392.413,1474.2,1372.434,1462.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1556.918,1340.299c0.106,14.871-0.366,29.763-1.279,44.642 C1556.553,1370.062,1557.024,1355.17,1556.918,1340.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1365.462,225.45c0.48,1.111,0.962,2.226,1.463,3.368 C1366.424,227.676,1365.942,226.561,1365.462,225.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1367.891,231.008c0.519,1.173,1.043,2.353,1.581,3.553 C1368.934,233.361,1368.41,232.18,1367.891,231.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1363.161,220.048c0.447,1.067,0.895,2.135,1.368,3.24 C1364.056,222.183,1363.608,221.114,1363.161,220.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1429.577,1650.877c2.379-20.864,6.65-41.532,8.157-62.487 c-7.953,12.003-15.325,24.519-22.929,36.802c-20.121,32.504-45.437,62.238-72.7,88.992c-9.207,9.036-18.853,17.65-28.933,25.707 c44.873-11.186,88.772-25.32,124.199-42.25c-2.083,0.995-4.173,1.987-6.313,2.963 C1427.099,1684.505,1427.685,1667.475,1429.577,1650.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M724.863,1707.878c-7.592-2.735-15.014-5.835-22.267-9.263 C709.849,1702.043,717.271,1705.143,724.863,1707.878c32.483,11.786,64.461,21.961,96.267,30.556c-0.001,0,0,0-0.001,0 C789.323,1729.838,757.346,1719.664,724.863,1707.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M554.863,757.865c1.652-3.341,3.294-6.689,4.977-10.011 C558.157,751.176,556.516,754.523,554.863,757.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M563.686,1576.726c3.421,4.562,6.884,9.092,10.436,13.556c7.268,9.134,14.862,18.085,22.765,26.766 c-7.904-8.68-15.497-17.632-22.765-26.766C570.57,1585.818,567.107,1581.287,563.686,1576.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M545.023,778.205c1.692-3.591,3.411-7.166,5.138-10.738 C548.434,771.039,546.715,774.613,545.023,778.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1361.01,214.821c0.433,1.074,0.867,2.149,1.331,3.273 C1361.877,216.97,1361.443,215.895,1361.01,214.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1370.498,236.844c0.565,1.253,1.138,2.516,1.72,3.793 C1371.636,239.36,1371.063,238.096,1370.498,236.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M473.352,1405.488c-1.736-5.067-3.405-10.157-5.013-15.266 C469.948,1395.331,471.615,1400.421,473.352,1405.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1485.571,1668.292c-0.009,0.008-0.019,0.015-0.028,0.022 C1485.552,1668.307,1485.562,1668.3,1485.571,1668.292c39.645-32.553,48.957-98.39,55.381-153.716h0 C1534.529,1569.902,1525.217,1635.739,1485.571,1668.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1418.95,342.106c0.749,1.159,1.584,2.462,2.47,3.856 C1420.531,344.564,1419.701,343.267,1418.95,342.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1497.102,1083.014c2.49,6.762,4.946,13.535,7.359,20.319 C1502.05,1096.548,1499.592,1089.776,1497.102,1083.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1148.778,1768.465c3.161-0.299,6.395-0.625,9.707-0.978 C1155.172,1767.841,1151.941,1768.164,1148.778,1768.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M504.171,875.945c1.589-4.327,3.193-8.65,4.833-12.964 C507.362,867.296,505.759,871.617,504.171,875.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M523.503,826.662c1.674-4.005,3.371-8,5.088-11.988 C526.874,818.662,525.178,822.657,523.503,826.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1137.807,1769.423c2.767-0.219,5.594-0.459,8.505-0.725 C1143.399,1768.965,1140.577,1769.202,1137.807,1769.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M511.474,856.6c2.888-7.467,5.854-14.91,8.895-22.328 C517.327,841.691,514.363,849.133,511.474,856.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1373.168,242.717c0.658,1.437,1.325,2.886,2.001,4.347 C1374.493,245.604,1373.826,244.154,1373.168,242.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1375.951,248.755c0.771,1.662,1.552,3.336,2.34,5.018 C1377.503,252.09,1376.723,250.416,1375.951,248.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M633.749,622.833c1.466-2.134,2.943-4.257,4.423-6.374 C636.691,618.576,635.217,620.699,633.749,622.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M727.154,508.182c0.772-0.79,1.556-1.554,2.33-2.338 C728.71,506.629,727.926,507.392,727.154,508.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M709.198,527.249c1.238-1.357,2.472-2.723,3.716-4.068 C711.669,524.526,710.436,525.892,709.198,527.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M677.749,563.85c1.138-1.404,2.266-2.824,3.41-4.218 C680.014,561.026,678.886,562.446,677.749,563.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M647.954,602.721c0.972-1.34,1.929-2.702,2.906-4.035 C649.883,600.019,648.926,601.381,647.954,602.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1536.421,1204.014c0.935,3.399,1.907,6.79,2.811,10.196 C1538.329,1210.804,1537.357,1207.413,1536.421,1204.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M793.972,443.855c0.854-0.902,1.699-1.802,2.534-2.699 C795.67,442.054,794.827,442.953,793.972,443.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M786.977,451.091c1.269-1.286,2.533-2.572,3.763-3.848 C789.509,448.519,788.246,449.804,786.977,451.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M778.368,459.633c1.74-1.686,3.441-3.359,5.114-5.024 C781.807,456.274,780.109,457.947,778.368,459.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M770.957,466.67c1.646-1.536,3.263-3.064,4.85-4.582 C774.218,463.607,772.603,465.133,770.957,466.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M761.179,475.614c2.53-2.26,4.978-4.493,7.382-6.712 C766.157,471.121,763.71,473.354,761.179,475.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M742.072,493.406c1.321-1.274,2.642-2.546,3.969-3.806 C744.715,490.86,743.393,492.132,742.072,493.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M663.414,581.993c1.331-1.733,2.675-3.446,4.016-5.165 C666.089,578.547,664.745,580.26,663.414,581.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M920.455,268.425c2.354-3.003,4.796-6.054,7.299-9.136 C925.249,262.373,922.812,265.421,920.455,268.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M568.591,730.936c1.625-3.081,3.281-6.14,4.932-9.202 C571.872,724.797,570.216,727.854,568.591,730.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M579.368,711.027c1.615-2.922,3.228-5.847,4.867-8.75 C582.595,705.18,580.984,708.104,579.368,711.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M929.885,256.673c2.887-3.521,5.847-7.079,8.951-10.714 C935.732,249.594,932.775,253.151,929.885,256.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1358.671,208.853c0.525,1.395,1.091,2.856,1.692,4.37 C1359.762,211.709,1359.196,210.249,1358.671,208.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1529.078,1178.403c1.314,4.4,2.645,8.795,3.91,13.205 C1531.723,1187.198,1530.391,1182.802,1529.078,1178.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M799.889,437.501c0.538-0.589,1.057-1.173,1.589-1.761 C800.946,436.328,800.427,436.912,799.889,437.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M620.164,643.102c1.326-2.031,2.664-4.049,4.001-6.067 C622.827,639.053,621.49,641.07,620.164,643.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1521.516,1153.885c1.63,5.108,3.259,10.215,4.828,15.337 C1524.776,1164.1,1523.145,1158.993,1521.516,1153.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M903.394,291.129c5.017-6.972,10.367-14.138,16.138-21.535 C913.753,276.996,908.411,284.157,903.394,291.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M594.096,685.145c1.409-2.395,2.85-4.759,4.274-7.139 C596.945,680.386,595.505,682.75,594.096,685.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M605.705,665.92c1.553-2.52,3.111-5.036,4.681-7.538C608.815,660.884,607.259,663.4,605.705,665.92z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M694.575,543.696c1.129-1.308,2.272-2.59,3.406-3.888 C696.847,541.106,695.705,542.388,694.575,543.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1478.96,1673.398c-0.766,0.564-1.562,1.122-2.348,1.681 C1477.397,1674.519,1478.193,1673.962,1478.96,1673.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1445.448,1693.663c-1.897,0.965-3.813,1.924-5.763,2.873 C1441.635,1695.587,1443.553,1694.629,1445.448,1693.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M457.229,1350.404c-1.31-5.367-2.554-10.75-3.722-16.149 C454.675,1339.654,455.919,1345.037,457.229,1350.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1340.186,481.394c-1.116,1.484-2.399,2.755-3.753,3.932c2.659,2.225,5.174,4.605,7.464,7.218 c1.115-1.508,2.147-3.076,3.092-4.695c2.098-3.595,3.157-6.061,4.333-9.84c0.122-0.392,0.347-0.701,0.545-1.032 c-2.756-1.296-5.324-2.987-7.583-5.021C1343.691,475.318,1342.299,478.587,1340.186,481.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1453.675,1689.333c-1.676,0.917-3.401,1.82-5.127,2.722 C1450.273,1691.153,1452,1690.251,1453.675,1689.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1463.973,1683.37c-1.667,1.014-3.361,2.02-5.091,3.017 C1460.612,1685.389,1462.307,1684.384,1463.973,1683.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1471.804,1678.392c-0.969,0.646-1.939,1.294-2.934,1.933 C1469.865,1679.685,1470.836,1679.038,1471.804,1678.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1488.63,1060.378c2.703,7.101,5.37,14.215,7.999,21.34 C1494.001,1074.592,1491.333,1067.48,1488.63,1060.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1465.089,427.754c0.008-0.003,0.016-0.007,0.025-0.01c-2.348-5.604-4.844-11.192-7.449-16.691 c-0.005,0.004-0.011,0.008-0.017,0.012C1460.251,416.564,1462.742,422.151,1465.089,427.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1418.923,342.063c0.371,0.5,0.676,0.881,0.919,1.151c-0.244-0.271-0.551-0.654-0.923-1.156 C1418.92,342.059,1418.921,342.062,1418.923,342.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1453.601,402.708c-4.319-8.682-8.771-17.015-13.074-24.706c4.3,7.688,8.757,16.029,13.071,24.708 C1453.599,402.709,1453.6,402.708,1453.601,402.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1419.845,343.218c5.423,6.009-20.189-43.901-41.019-88.303 C1399.64,299.288,1425.271,349.234,1419.845,343.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M467.476,1387.474c-3.546-11.458-6.77-23.014-9.659-34.655 C460.707,1364.46,463.929,1376.017,467.476,1387.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M502.456,1476.149c-2.579-5.318-5.099-10.665-7.526-16.054 C497.358,1465.484,499.876,1470.832,502.456,1476.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M510.547,1492.212c-2.207-4.236-4.365-8.496-6.474-12.781 C506.182,1483.716,508.34,1487.977,510.547,1492.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M494.837,1459.883c-2.357-5.237-4.622-10.514-6.836-15.814 C490.215,1449.369,492.48,1454.646,494.837,1459.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M486.626,1440.741c-2.037-4.958-4.019-9.938-5.928-14.946 C482.608,1430.804,484.589,1435.784,486.626,1440.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M480.157,1424.403c-2.141-5.654-4.197-11.34-6.175-17.053 C475.96,1413.063,478.016,1418.749,480.157,1424.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M520.653,1510.888c-2.857-5.056-5.632-10.16-8.346-15.294 C515.022,1500.728,517.794,1505.831,520.653,1510.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M654.98,1669.945c-14.198-10.421-27.648-21.985-40.319-34.411 C627.332,1647.96,640.783,1659.524,654.98,1669.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1160.16,1767.308c3.931-0.426,7.943-0.885,12.061-1.384 C1168.105,1766.424,1164.092,1766.881,1160.16,1767.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M614.589,1635.461c-5.591-5.485-11.03-11.135-16.331-16.907 C603.559,1624.326,608.997,1629.976,614.589,1635.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M529.351,1525.738c-2.69-4.464-5.333-8.956-7.909-13.486 C524.018,1516.782,526.66,1521.274,529.351,1525.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M539.364,1541.786c-2.582-4-5.115-8.03-7.603-12.088 C534.248,1533.756,536.782,1537.786,539.364,1541.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M550.599,1558.602c-3.24-4.672-6.42-9.385-9.527-14.146 C544.18,1549.216,547.359,1553.93,550.599,1558.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M560.818,1572.854c-2.661-3.609-5.282-7.246-7.862-10.913 C555.537,1565.608,558.157,1569.246,560.818,1572.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M487.169,925.636c4.548-14.33,9.398-28.633,14.531-42.881 C496.566,897.005,491.719,911.304,487.169,925.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1513.623,1129.812c1.936,5.736,3.856,11.475,5.722,17.228 C1517.479,1141.287,1515.558,1135.548,1513.623,1129.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M480.966,945.739c1.345-4.519,2.74-9.037,4.145-13.554 C483.706,936.703,482.311,941.218,480.966,945.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1432.311,363.73c2.587,4.371,5.324,9.101,8.133,14.121 C1437.633,372.831,1434.899,368.101,1432.311,363.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1125.412,1770.297c3.179-0.185,6.519-0.417,9.948-0.676 C1131.927,1769.882,1128.593,1770.112,1125.412,1770.297c-34.769,2.023-68.643,2.194-101.983,0.582 C1056.769,1772.49,1090.644,1772.32,1125.412,1770.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M453.173,1332.74c-1.296-6.064-2.509-12.146-3.626-18.246 C450.664,1320.594,451.877,1326.676,453.173,1332.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1542.057,1504.98L1542.057,1504.98c1.269-11.076,2.484-21.609,3.882-31.202 c4.28-29.373,7.873-59.079,9.7-88.837c-1.827,29.758-5.421,59.463-9.701,88.836 C1544.541,1483.371,1543.325,1493.905,1542.057,1504.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1476.2,459.476c0.017-0.003,0.034-0.005,0.051-0.008c-2.049-7.57-4.671-15.385-7.715-23.261 c-0.015,0.006-0.029,0.012-0.045,0.018C1471.532,444.1,1474.153,451.906,1476.2,459.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1424.927,351.548c1.063,1.712,2.174,3.519,3.34,5.437 C1427.101,355.067,1425.99,353.26,1424.927,351.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1428.347,357.117c1.137,1.874,2.326,3.855,3.545,5.906 C1430.673,360.973,1429.485,358.991,1428.347,357.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1421.932,346.771c0.777,1.228,1.602,2.54,2.464,3.925 C1423.532,349.309,1422.71,348.001,1421.932,346.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1505.453,1106.155c2.23,6.302,4.432,12.612,6.588,18.934 C1509.887,1118.766,1507.682,1112.457,1505.453,1106.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B590"
    },
    d: "M1556.615,1325.437c-1.012-29.705-4.513-59.276-11.586-88.436c-0.108-0.445-0.23-0.887-0.339-1.332 c0.109,0.445,0.23,0.887,0.338,1.332C1552.102,1266.161,1555.603,1295.732,1556.615,1325.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97D5E"
    },
    d: "M585.141,928.722c32.379-14.829,62.96-33.334,95.745-47.312 c31.934-13.615,64.513-21.424,99.318-17.84c32.282,3.325,64.532,8.563,97.068,8.362c30.84-0.191,63.583-5.796,87.066-27.391 c23.928-22.005,38.546-59.178,31.358-91.486c-6.604-29.677-29.517-52.134-52.19-70.743c-24.101-19.781-50.693-36.472-73.911-57.34 c-28.211-25.356-49.023-57.519-57.686-94.623c-7.495-32.098-7.288-65.418-7.102-98.299c0-0.005,0-0.01,0-0.016 c-1.087,1.229-2.21,2.469-3.328,3.706c-0.531,0.588-1.05,1.172-1.589,1.761c-1.106,1.212-2.244,2.434-3.383,3.655 c-0.836,0.898-1.681,1.797-2.534,2.699c-1.065,1.126-2.137,2.254-3.231,3.388c-1.23,1.276-2.495,2.562-3.763,3.848 c-1.151,1.168-2.312,2.34-3.496,3.518c-1.673,1.665-3.374,3.338-5.114,5.024c-0.841,0.814-1.704,1.635-2.56,2.455 c-1.587,1.518-3.204,3.046-4.85,4.582c-0.795,0.743-1.587,1.484-2.396,2.232c-2.404,2.219-4.851,4.452-7.382,6.712 c-0.044,0.04-0.087,0.079-0.132,0.119c-5.047,4.505-10.039,9.154-15.006,13.867c-1.327,1.26-2.649,2.532-3.969,3.806 c-4.226,4.076-8.424,8.217-12.588,12.438c-0.774,0.785-1.558,1.549-2.33,2.338c-4.791,4.902-9.534,9.913-14.241,15 c-1.244,1.344-2.477,2.71-3.716,4.068c-3.767,4.13-7.506,8.316-11.216,12.559c-1.134,1.298-2.277,2.579-3.406,3.888 c-4.517,5.232-8.99,10.543-13.417,15.936c-1.144,1.393-2.272,2.814-3.41,4.218c-3.469,4.279-6.909,8.605-10.319,12.978 c-1.341,1.719-2.685,3.432-4.016,5.165c-4.226,5.501-8.419,11.054-12.553,16.693c-0.977,1.333-1.934,2.695-2.906,4.035 c-3.292,4.538-6.553,9.117-9.783,13.738c-1.48,2.117-2.956,4.24-4.423,6.374c-3.227,4.694-6.421,9.429-9.584,14.202 c-1.337,2.018-2.675,4.035-4.001,6.067c-3.296,5.052-6.554,10.148-9.778,15.281c-1.571,2.501-3.128,5.018-4.681,7.538 c-2.469,4.005-4.911,8.035-7.335,12.085c-1.424,2.38-2.865,4.744-4.274,7.139c-3.334,5.668-6.617,11.384-9.861,17.131 c-1.639,2.903-3.252,5.828-4.867,8.75c-1.966,3.556-3.913,7.125-5.845,10.708c-1.65,3.062-3.307,6.121-4.932,9.202 c-2.958,5.611-5.88,11.247-8.751,16.918c-1.682,3.322-3.324,6.67-4.977,10.011c-1.579,3.194-3.151,6.391-4.702,9.601 c-1.726,3.572-3.446,7.147-5.138,10.738c-1.496,3.177-2.959,6.371-4.428,9.563c-2.834,6.156-5.617,12.337-8.347,18.543 c-1.225,2.785-2.453,5.569-3.657,8.365c-1.717,3.987-3.415,7.983-5.088,11.988c-1.058,2.531-2.094,5.071-3.134,7.609 c-3.041,7.418-6.007,14.862-8.895,22.328c-0.824,2.127-1.66,4.25-2.47,6.38c-1.641,4.314-3.245,8.637-4.833,12.964 c-0.833,2.268-1.651,4.539-2.47,6.811c-5.133,14.248-9.983,28.551-14.531,42.881c-0.693,2.183-1.38,4.365-2.058,6.549 c-1.404,4.517-2.8,9.034-4.145,13.554c-0.007,0.024-0.015,0.047-0.021,0.071c0.001,0,0.001,0,0.001,0 c2.962,0.753,5.945,1.429,8.97,1.934C522.733,953.217,555.645,942.231,585.141,928.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97D5E"
    },
    d: "M1156.124,1133.901c-27.024,21.869-43.344,54.994-50.082,88.675 c-8.558,42.772,8,84.097,36.09,116.077c28.373,32.303,65.819,56.338,104.912,73.631c41.063,18.163,86.592,26.778,125.391,49.973 c19.979,11.944,36.927,28.115,48.958,48.11c11.278,18.744,16.337,39.431,16.809,60.98c10.463-14.49,22.271-27.868,37.104-38.731 c19.537-14.31,42.728-23.729,66.751-27.635c1.268-11.076,2.484-21.609,3.881-31.203c4.28-29.373,7.874-59.078,9.701-88.836 c0.913-14.879,1.385-29.772,1.279-44.642c-0.035-4.957-0.135-9.911-0.303-14.862c-1.012-29.705-4.513-59.276-11.587-88.436 c-0.108-0.445-0.229-0.887-0.338-1.332c-1.749-7.167-3.563-14.321-5.458-21.459c-0.903-3.406-1.875-6.797-2.811-10.196 c-1.139-4.137-2.251-8.279-3.434-12.406c-1.265-4.41-2.595-8.806-3.91-13.205c-0.913-3.06-1.797-6.126-2.733-9.181 c-1.57-5.121-3.198-10.229-4.828-15.337c-0.728-2.281-1.432-4.567-2.171-6.845c-1.866-5.752-3.786-11.492-5.722-17.228 c-0.531-1.573-1.046-3.151-1.583-4.724c-2.155-6.322-4.357-12.632-6.588-18.934c-0.333-0.94-0.657-1.883-0.991-2.822 c-2.413-6.784-4.869-13.557-7.359-20.319c-0.159-0.432-0.314-0.864-0.474-1.296c-2.629-7.125-5.296-14.239-7.999-21.34 c-0.016-0.041-0.031-0.083-0.047-0.125h0c-43.215,32.824-103.736,34.094-155.924,35.498 C1274.076,1097.326,1204.398,1094.835,1156.124,1133.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97D5E"
    },
    d: "M1540.952,1514.576c-17.325,3.145-34.113,9.308-49.242,18.271 c-23.24,13.769-39.573,33.804-53.976,55.542c-1.507,20.955-5.778,41.623-8.157,62.487c-1.892,16.598-2.478,33.627,1.483,49.727 c2.14-0.976,4.23-1.968,6.313-2.963c0.771-0.369,1.549-0.734,2.312-1.105c1.951-0.948,3.867-1.907,5.763-2.873 c1.045-0.532,2.072-1.07,3.1-1.608c1.726-0.902,3.45-1.805,5.127-2.722c1.775-0.971,3.492-1.959,5.207-2.947 c1.731-0.997,3.424-2.003,5.091-3.017c1.659-1.008,3.303-2.019,4.898-3.045c0.995-0.64,1.964-1.287,2.934-1.933 c1.642-1.095,3.242-2.2,4.807-3.313c0.787-0.559,1.582-1.116,2.348-1.681c2.276-1.676,4.491-3.366,6.583-5.083 c0.009-0.008,0.019-0.015,0.028-0.022C1525.217,1635.739,1534.529,1569.902,1540.952,1514.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97D5E"
    },
    d: "M821.129,1738.433c-0.148-0.165-0.31-0.312-0.458-0.478c-3.939-4.43,2.572-10.979,6.528-6.529 c3.644,4.099,7.557,7.909,11.595,11.577c60.412,15.21,120.418,24.598,182.242,27.75c0.798,0.04,1.595,0.087,2.393,0.126 c33.34,1.612,67.214,1.442,101.983-0.582c3.181-0.185,6.515-0.415,9.948-0.676c0.799-0.06,1.635-0.133,2.447-0.198 c2.77-0.22,5.592-0.458,8.505-0.725c0.814-0.075,1.64-0.154,2.466-0.233c3.163-0.3,6.394-0.624,9.707-0.978 c0.56-0.059,1.112-0.117,1.675-0.179c3.932-0.427,7.946-0.885,12.061-1.384c0.002,0,0.005,0,0.006,0l0,0 c-0.901-4.707-1.727-9.428-2.473-14.164c-5.729-36.372-7.832-74.974-25.263-108.185c-19.43-37.021-55.719-58.661-94.421-71.083 c-37.085-11.902-77.123-16.691-112.115-34.47c-28.94-14.704-51.855-37.728-70.105-64.272 c-38.012-55.289-59.617-120.486-98.446-175.255c-13.988-19.731-31.702-37.261-54.753-45.822 c-29.006-10.772-61.412-8.526-91.383-3.664c-37.589,6.098-71.696,27.448-105.833,43.139c-21.354,9.816-44.338,19.324-67.89,22.332 l0,0c0.001,0.005,0.003,0.01,0.003,0.014c1.117,6.1,2.329,12.182,3.626,18.246c0.108,0.506,0.224,1.009,0.334,1.515 c1.168,5.399,2.413,10.782,3.722,16.149c0.196,0.805,0.389,1.611,0.588,2.416c2.889,11.64,6.113,23.197,9.659,34.655 c0.284,0.917,0.576,1.832,0.864,2.747c1.608,5.109,3.277,10.2,5.013,15.266c0.213,0.62,0.415,1.242,0.63,1.861 c1.978,5.713,4.035,11.399,6.175,17.053c0.177,0.465,0.363,0.927,0.54,1.392c1.91,5.008,3.892,9.988,5.928,14.946 c0.457,1.11,0.913,2.22,1.375,3.328c2.213,5.299,4.479,10.577,6.836,15.814c0.031,0.07,0.061,0.142,0.093,0.213 c2.427,5.389,4.947,10.736,7.526,16.054c0.532,1.098,1.078,2.188,1.617,3.282c2.109,4.285,4.267,8.545,6.474,12.781 c0.587,1.127,1.165,2.258,1.76,3.381c2.714,5.135,5.489,10.238,8.346,15.294c0.258,0.457,0.529,0.907,0.789,1.364 c2.576,4.531,5.22,9.023,7.909,13.486c0.798,1.324,1.602,2.642,2.41,3.96c2.488,4.059,5.021,8.089,7.603,12.088 c0.573,0.888,1.131,1.785,1.708,2.67c3.107,4.761,6.288,9.474,9.527,14.146c0.777,1.12,1.574,2.226,2.357,3.34 c2.58,3.666,5.201,7.304,7.862,10.913c0.953,1.293,1.904,2.587,2.867,3.871c3.421,4.562,6.884,9.092,10.436,13.555 c7.268,9.134,14.862,18.086,22.765,26.766c0.458,0.502,0.911,1.006,1.371,1.507c5.301,5.772,10.74,11.422,16.331,16.907 c0.024,0.024,0.048,0.049,0.072,0.073c12.671,12.426,26.122,23.99,40.319,34.411c15.003,11.012,30.845,20.742,47.616,28.67 c7.253,3.428,14.675,6.528,22.267,9.263C757.346,1719.664,789.323,1729.838,821.129,1738.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97D5E"
    },
    d: "M1398.928,632.411c2.183-1.241,4.222-0.497,5.521,0.948c0.673-0.481,1.286-0.907,1.976-1.403 c1.731-1.244,3.401-2.593,5.091-3.909c-5.259-1.185-10.529-2.326-15.828-3.327c-45.352-8.568-105.604-11.407-128.508,36.818 c1.107,0.447,2.238,0.815,3.364,1.2C1315.264,665.035,1359.896,654.601,1398.928,632.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B97D5E"
    },
    d: "M905.029,428.851c2.658-1.156,6.626,0.157,6.87,3.997c0.9,14.185,1.044,28.423,2.295,42.584 c2.153,24.351,10.304,45.777,26.991,63.941c4.995,5.438,10.455,10.406,16.104,15.158c69.839,39.657,179.755-2.758,241.467-40.655 c43.872-26.942,53.457-64.21,76.245-106.854c5.876-10.995,13.02-21.506,25.779-24.626c29.385-7.188,47.613,25.778,62.169,45.325 c19.662,26.403,49.642,34.747,81.635,37.064c0.697-0.661,1.549-1.191,2.689-1.338c9.656-1.244,19.297-2.579,28.929-3.972 c-2.047-7.57-4.668-15.376-7.709-23.251c-7.876,3.165-15.732,6.382-23.541,9.715c-5.409,2.309-10.108-5.648-4.66-7.972 c8.224-3.51,16.501-6.887,24.799-10.213c-2.346-5.604-4.838-11.191-7.441-16.69c-8.285,5.38-16.53,10.825-24.672,16.424 c-4.913,3.378-9.526-4.627-4.66-7.973c8.34-5.734,16.789-11.304,25.282-16.806c-4.314-8.678-8.771-17.02-13.071-24.708 c-0.028-0.05-0.056-0.1-0.084-0.15c-2.809-5.02-5.546-9.751-8.133-14.121c-0.142-0.238-0.279-0.47-0.419-0.706 c-1.218-2.052-2.407-4.032-3.545-5.906c-0.027-0.043-0.053-0.089-0.08-0.132c-1.166-1.918-2.277-3.725-3.34-5.437 c-0.183-0.295-0.351-0.563-0.532-0.852c-0.862-1.385-1.687-2.698-2.464-3.925c-0.172-0.271-0.345-0.546-0.511-0.809 c-0.886-1.394-1.721-2.697-2.47-3.856c-0.009-0.013-0.02-0.03-0.027-0.042c-0.002-0.001-0.003-0.004-0.004-0.005 c0.372,0.502,0.678,0.885,0.923,1.156c0.001,0.001,0.003,0.003,0.004,0.005c5.426,6.016-20.206-43.93-41.019-88.303 c-0.179-0.382-0.356-0.761-0.535-1.143c-0.788-1.683-1.569-3.357-2.34-5.018c-0.263-0.566-0.521-1.128-0.782-1.691 c-0.676-1.461-1.343-2.91-2.001-4.347c-0.319-0.697-0.636-1.389-0.95-2.08c-0.582-1.277-1.154-2.54-1.72-3.793 c-0.345-0.765-0.688-1.527-1.026-2.283c-0.538-1.2-1.062-2.38-1.581-3.553c-0.324-0.733-0.65-1.468-0.966-2.189 c-0.501-1.143-0.983-2.258-1.463-3.368c-0.313-0.723-0.631-1.454-0.933-2.163c-0.473-1.105-0.921-2.173-1.368-3.24 c-0.273-0.652-0.556-1.318-0.82-1.954c-0.464-1.124-0.898-2.199-1.331-3.273c-0.213-0.529-0.441-1.081-0.646-1.598 c-0.601-1.514-1.167-2.975-1.692-4.37c-0.016-0.04-0.034-0.086-0.049-0.127c-4.71-12.537-10.893-26.553-23.607-30.761 c-20.927-6.926-29.705,32.728-51.728,33.69c-59.283,2.591-144.375,39.139-192.168,2.591 c-72.873-55.726-74.603-59.211-152.243,31.664c-0.014,0.016-0.026,0.031-0.039,0.047c-3.105,3.635-6.064,7.193-8.951,10.714 c-0.718,0.877-1.424,1.746-2.13,2.616c-2.503,3.083-4.946,6.133-7.299,9.136c-0.303,0.388-0.62,0.782-0.923,1.168 c-5.771,7.397-11.121,14.564-16.138,21.535c0,0.001-0.001,0.003-0.003,0.004l0,0c0.182,0.874,0.637,1.72,0.585,2.611 C901.271,340.043,901.01,384.515,905.029,428.851z M975.482,283.894c5.828-26.543,18.777-51.03,37.151-70.984 c0.951-1.811,1.903-3.623,2.853-5.435c0.871-1.66,3.413-2.837,5.214-2.122c19.505,7.752,39.01,15.503,58.516,23.255 c5.465,2.172,3.068,11.098-2.455,8.903c-18.141-7.209-36.281-14.418-54.421-21.628c-0.063,0.072-0.075,0.153-0.144,0.223 c-0.675,0.691-1.284,1.433-1.944,2.136c-12.111,23.069-24.221,46.139-36.331,69.208 C981.377,292.295,974.408,288.788,975.482,283.894z M1015.28,432.927c33.752,3.007,67.35,7.294,100.854,12.344 c25.829,3.893,51.605,8.273,77.577,11.133c5.852,0.645,5.898,9.883,0,9.233c-25.602-2.819-51.022-7.061-76.479-10.925 c-33.869-5.143-67.826-9.512-101.952-12.552C1009.398,441.635,1009.363,432.399,1015.28,432.927z M1017.268,501.147 c-5.892,0.73-5.82-8.512,0-9.233c59.461-7.373,119.104-11.742,178.79-16.728c5.931-0.495,5.878,8.742,0,9.233 C1136.373,489.405,1076.73,493.774,1017.268,501.147z M1204.329,503.037c-51.799,18.784-104.44,35.921-153.85,60.577 c-5.306,2.648-9.977-5.319-4.66-7.972c50.126-25.013,103.506-42.452,156.056-61.508 C1207.48,492.101,1209.872,501.027,1204.329,503.037z M1218.924,435.314c-10.086,1.877-20.252-7.293-22.707-20.482 c-2.454-13.189,3.732-25.403,13.818-27.28c10.086-1.877,20.251,7.293,22.706,20.482 C1235.196,421.223,1229.009,433.436,1218.924,435.314z M1370.069,358.022c10.086-1.877,20.251,7.292,22.706,20.482 c2.455,13.189-3.731,25.402-13.817,27.28c-10.085,1.877-20.252-7.293-22.707-20.482 C1353.796,372.113,1359.983,359.899,1370.069,358.022z M1327.918,200.321c1.736-1.619,4.836-1.914,6.529,0 c6.428,7.265,12.856,14.53,19.284,21.796c1.657,1.873,1.855,4.674,0,6.529c-1.687,1.687-4.876,1.868-6.529,0 c-5.444-6.154-10.888-12.307-16.333-18.46c-5.972,5.569-11.944,11.139-17.916,16.707c-4.344,4.051-10.884-2.467-6.529-6.529 C1313.59,213.684,1320.754,207.002,1327.918,200.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1210.035,387.552c-10.086,1.877-16.272,14.091-13.818,27.28 c2.455,13.189,12.621,22.359,22.707,20.482c10.085-1.877,16.272-14.091,13.817-27.28 C1230.286,394.845,1220.12,385.675,1210.035,387.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1356.251,385.302c2.455,13.189,12.621,22.359,22.707,20.482 c10.086-1.877,16.272-14.091,13.817-27.28c-2.455-13.19-12.62-22.359-22.706-20.482 C1359.983,359.899,1353.796,372.113,1356.251,385.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1330.753,467.384c1.698,0.524,3.258,0.743,4.705,0.722l-0.006,0.771 c-0.004,0.07-0.053,0.521-0.065,0.705c-0.127,0.743-0.284,1.481-0.504,2.201l-0.342,1.012l-0.231,0.599l0.031-0.122 c-0.349,0.707-0.717,1.399-1.142,2.065l-0.57,0.829c-0.054,0.05-0.476,0.575-0.507,0.611c-1.158,1.291-2.396,2.31-3.412,3.001 c-0.084,0.057-0.181,0.091-0.265,0.147c-1.855-0.326-3.962,0.505-4.845,2.176c-0.102,0.193-0.113,0.395-0.188,0.591 c-2.643,1.186-6.656,2.433-9.984,3.434c-2.387,0.718-3.896,3.235-3.225,5.679c0.651,2.368,3.283,3.946,5.679,3.224 c4.167-1.253,8.443-2.633,12.426-4.51c1.619,1.189,3.071,2.401,4.84,4.071c1.274,1.201,2.494,2.458,3.658,3.765 c0.582,0.654,1.15,1.32,1.703,1.998c-0.01-0.013,0.476,0.6,0.557,0.696l0.758,1.018c1.68,2.298,5.037,3.286,7.25,0.935 c6.048-6.428,10.531-14.112,13.154-22.54c0.093-0.3,0.05-0.616,0.069-0.927c3.607,0.54,7.309,0.425,10.901-0.508 c2.337-0.607,3.985-3.33,3.224-5.678c-0.779-2.409-3.174-3.875-5.679-3.225c-0.701,0.182-1.407,0.325-2.119,0.444 c-0.153,0.017-0.391,0.045-0.561,0.058l-0.986,0.052c-0.723,0.023-1.447,0.01-2.168-0.036l-1.179-0.107 c1.104,0.096-0.175-0.04-0.335-0.069c-1.5-0.275-2.954-0.706-4.385-1.228c-0.126-0.045-0.241-0.092-0.335-0.132l-0.932-0.437 c-0.714-0.355-1.411-0.741-2.091-1.157c-0.624-0.382-1.225-0.795-1.82-1.221l0.142,0.119l-0.464-0.376l-0.754-0.649 c-0.591-0.529-1.159-1.086-1.7-1.668l-0.787-0.89c-0.06-0.071-0.215-0.275-0.334-0.433c-0.392-0.551-0.695-1.155-1.046-1.731 c2.862-4.41,4.768-9.974,6.371-14.406c3.638-10.059-2.588-10.466-11.029-8.482c-9.855,2.003-19.57,5.058-28.977,8.589 c-1.261,0.473-2.612,1.035-3.291,2.198c-1.02,1.747-0.074,3.953,0.959,5.697C1314.764,460.74,1323.811,465.241,1330.753,467.384z  M1351.867,476.976c-0.199,0.331-0.424,0.641-0.545,1.032c-1.176,3.779-2.235,6.245-4.333,9.84 c-0.945,1.619-1.977,3.187-3.092,4.695c-2.29-2.612-4.804-4.993-7.464-7.218c1.354-1.177,2.637-2.448,3.753-3.932 c2.112-2.806,3.504-6.075,4.098-9.438C1346.543,473.988,1349.111,475.68,1351.867,476.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M914.194,475.432c-1.252-14.161-1.396-28.4-2.295-42.584c-0.244-3.84-4.212-5.153-6.87-3.997 c-1.426,0.621-2.495,1.921-2.363,3.997c1.568,24.704,0.297,50.616,8.362,74.367c10.003,29.459,33.712,50.833,58.459,68.328 c25.477,18.013,53.18,32.805,81.028,46.766c5.298,2.656,9.979-5.306,4.66-7.972c-24.519-12.292-48.809-25.263-71.709-40.4 c-9.042-5.977-17.857-12.407-26.177-19.405c-5.649-4.752-11.108-9.72-16.104-15.158 C924.498,521.209,916.347,499.783,914.194,475.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1164.786,756.214c27.096,24.423,60.882,39.308,94.129,53.326 c35.556,14.993,72.158,29.777,102.077,54.794c25.937,21.687,45.973,49.266,62.164,78.759c18.607,33.893,32.366,70.136,45.816,106.3 c2.053,5.521,10.981,3.132,8.903-2.454c-22.898-61.57-47.253-126.05-93.975-173.944c-25.662-26.306-57.4-44.101-90.759-58.832 c-34.667-15.308-70.883-28.062-102.48-49.419c-30.852-20.853-57.818-52.554-61.541-90.879c-0.569-5.861-9.808-5.92-9.233,0 C1123.038,706.303,1140.92,734.703,1164.786,756.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1022.195,216.107c0.069-0.071,0.081-0.152,0.144-0.223c18.141,7.209,36.281,14.418,54.421,21.628 c5.523,2.195,7.92-6.732,2.455-8.903c-19.506-7.751-39.011-15.503-58.516-23.255c-1.801-0.715-4.343,0.462-5.214,2.122 c-0.95,1.812-1.902,3.624-2.853,5.435c-18.374,19.954-31.323,44.441-37.151,70.984c-1.074,4.894,5.895,8.401,8.438,3.558 c12.11-23.069,24.22-46.139,36.331-69.208C1020.912,217.541,1021.521,216.798,1022.195,216.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1312.954,226.894c5.971-5.569,11.944-11.139,17.916-16.707c5.445,6.153,10.888,12.306,16.333,18.46 c1.653,1.868,4.841,1.687,6.529,0c1.855-1.855,1.657-4.656,0-6.529c-6.428-7.266-12.856-14.531-19.284-21.796 c-1.693-1.914-4.794-1.619-6.529,0c-7.164,6.681-14.328,13.363-21.493,20.044C1302.07,224.427,1308.61,230.945,1312.954,226.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1117.232,454.712c25.457,3.865,50.877,8.106,76.479,10.925c5.898,0.65,5.852-8.589,0-9.233 c-25.971-2.86-51.748-7.24-77.577-11.133c-33.504-5.05-67.103-9.337-100.854-12.344c-5.917-0.528-5.882,8.709,0,9.233 C1049.406,445.201,1083.363,449.569,1117.232,454.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1196.059,475.186c-59.686,4.986-119.329,9.355-178.79,16.728c-5.82,0.721-5.892,9.964,0,9.233 c59.461-7.373,119.104-11.742,178.79-16.728C1201.937,483.928,1201.99,474.691,1196.059,475.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1201.875,494.134c-52.55,19.056-105.931,36.495-156.056,61.508 c-5.317,2.653-0.646,10.621,4.66,7.972c49.41-24.656,102.052-41.793,153.85-60.577 C1209.872,501.027,1207.48,492.101,1201.875,494.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1428.316,419.516c-4.865,3.346-0.253,11.351,4.66,7.973c8.142-5.599,16.387-11.044,24.672-16.424 c0.006-0.004,0.012-0.008,0.017-0.012c45.903-29.804,93.239-57.347,133.737-94.678c4.378-4.036-2.164-10.553-6.53-6.529 c-39.731,36.624-86.196,63.663-131.271,92.861c-0.001,0-0.002,0.001-0.003,0.002 C1445.105,408.211,1436.655,413.781,1428.316,419.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1440.29,437.967c-5.448,2.325-0.749,10.281,4.66,7.972c7.809-3.333,15.665-6.55,23.541-9.715 c0.015-0.006,0.03-0.012,0.045-0.018c47.484-19.077,95.983-35.629,143.062-55.72c5.448-2.325,0.75-10.281-4.66-7.972 c-46.669,19.917-94.732,36.361-141.824,55.23c-0.008,0.003-0.016,0.007-0.025,0.01 C1456.791,431.08,1448.514,434.457,1440.29,437.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1447.271,463.448c-1.14,0.147-1.992,0.677-2.689,1.338c-2.857,2.708-2.044,8.505,2.689,7.896 c10.401-1.34,20.784-2.787,31.157-4.287c25.738-3.722,51.407-7.882,77.039-12.326c25.469-4.416,50.942-8.998,76.69-11.465 c5.863-0.562,5.921-9.801,0-9.233c-25.535,2.446-50.813,6.879-76.071,11.261c-26.565,4.609-53.159,8.979-79.836,12.838 c-0.017,0.002-0.034,0.005-0.051,0.008C1466.568,460.869,1456.927,462.204,1447.271,463.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1398.928,632.411c-39.032,22.19-83.665,32.624-128.385,30.327c-2.889-0.148-5.778-0.345-8.667-0.6 c-5.917-0.522-5.882,8.714,0,9.233c38.349,3.385,77.018-2.582,112.535-16.93c9.998-4.039,19.76-8.704,29.177-14.058 c2.987-1.699,2.643-5.041,0.861-7.024c0,0,0-0.001,0-0.001C1403.15,631.914,1401.111,631.17,1398.928,632.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#332F28"
    },
    d: "M1677.049,1561.161c-16.927-34.652-56.185-53.109-92.906-57.283 c-13.944-1.586-28.154-1.163-42.085,1.102l0,0c-24.023,3.906-47.214,13.326-66.751,27.635 c-14.833,10.863-26.642,24.241-37.104,38.731c-13.524,18.731-24.797,39.323-37.426,58.761 c-21.004,32.327-48.039,62.342-76.53,88.266c-10.665,9.704-21.957,18.709-33.789,26.911c-17.113,11.864-35.391,21.998-54.828,29.71 c-30.696,12.181-63.003,18.07-95.68,21.804c-29.457,3.366-59.109,5.238-88.762,5.259c-64.263,0.046-134.976-6.989-190.479-42.253 c-7.809-4.962-15.098-10.611-21.913-16.802l0,0c-4.038-3.668-7.951-7.478-11.595-11.577c-3.956-4.45-10.467,2.099-6.528,6.529 c0.147,0.166,0.31,0.313,0.458,0.478c0.001,0,0,0,0.001,0c41.645,46.445,106.776,63.255,166.59,69.672 c57.864,6.207,116.769,3.194,174.3-4.891c34.554-4.856,68.267-14.072,99.513-29.815c18.399-9.271,35.58-20.671,51.64-33.507 c10.08-8.057,19.726-16.671,28.933-25.707c27.263-26.755,52.579-56.488,72.7-88.992c7.603-12.284,14.976-24.799,22.929-36.802 c14.403-21.738,30.736-41.773,53.976-55.542c15.129-8.963,31.917-15.126,49.242-18.271h0c20.601-3.74,41.964-3.198,62.235,2.186 c18.599,4.939,36.501,13.958,50.278,27.56c15.786,15.586,22.874,35.769,23.712,57.697c1.542,40.329-7.817,82.778-21.392,120.557 c-13.631,37.931-34.156,73.732-61.99,103.041c-56.691,59.694-137.906,83.377-216.942,95.661 c-40.313,6.265-81.032,10.195-121.658,13.798c-40.183,3.564-80.47,6.191-120.812,6.868c-79.753,1.337-160.767-4.72-237.079-29.307 c-36.972-11.912-72.469-28.34-104.928-49.734c-30.706-20.239-61.692-46.789-70.552-84.259 c-3.841-16.247-1.164-32.592,10.489-44.999c4.066-4.328-2.45-10.871-6.529-6.529c-25.351,26.99-13.78,65.206,5.195,92.285 c22.139,31.597,56.477,53.417,90.073,71.21c71.378,37.804,151.934,53.92,231.977,58.905c82.972,5.168,166.216-1.167,248.746-9.711 c81.379-8.425,166.654-18.907,238.669-60.712c71.715-41.63,116.966-113.652,135.865-193.259c4.726-19.907,7.897-40.245,9.48-60.645 C1687.468,1603.543,1686.753,1581.026,1677.049,1561.161z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat5);
export default __webpack_public_path__ + "static/media/cat5.5140e426f482e0e75ef8c46c94ffe434.svg";
export { ForwardRef as ReactComponent };